module.exports = {
	"id": "BE",
	"name": "Belgium",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.006868,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.006868,
			"22": 0.013736,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006868,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.048076,
			"32": 0.020604,
			"33": 0.013736,
			"34": 0.027472,
			"35": 0.03434,
			"36": 0.027472,
			"37": 0.041208,
			"38": 0.041208,
			"39": 0.082416,
			"40": 0.03434,
			"41": 0.054944,
			"42": 0.061812,
			"43": 0.089284,
			"44": 0.054944,
			"45": 0.048076,
			"46": 0.048076,
			"47": 0.054944,
			"48": 0.06868,
			"49": 1.627716,
			"50": 0.10302,
			"51": 0.370872,
			"52": 0.398344,
			"53": 23.605316,
			"54": 6.139992,
			"55": 0.048076,
			"56": 0.013736,
			"57": null
		},
		"firefox": {
			"2": 0.013736,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.020604,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.006868,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006868,
			"27": null,
			"28": 0.006868,
			"29": 0.006868,
			"30": 0.006868,
			"31": 0.020604,
			"32": 0.013736,
			"33": 0.020604,
			"34": 0.006868,
			"35": 0.027472,
			"36": 0.020604,
			"37": 0.027472,
			"38": 0.123624,
			"39": 0.03434,
			"40": 0.027472,
			"41": 0.027472,
			"42": 0.041208,
			"43": 0.096152,
			"44": 0.054944,
			"45": 0.30906,
			"46": 0.06868,
			"47": 0.460156,
			"48": 0.714272,
			"49": 8.227864,
			"50": 0.048076,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.013736
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.027472,
			"37": 0.013736,
			"38": 0.027472,
			"39": 0.013736,
			"40": 0.357136,
			"41": 0.054944,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.03434
		},
		"safari": {
			"0": null,
			"4": 0.020604,
			"5": 0.075548,
			"6": 0.013736,
			"7": 0.061812,
			"8": 0.30906,
			"9": 0.439552,
			"10": 3.015052,
			"3.1": null,
			"3.2": null,
			"5.1": 0.185436,
			"6.1": 0.130492,
			"7.1": 0.020604,
			"9.1": 1.909304
		},
		"ios_saf": {
			"8": 0,
			"10": 7.57280829642,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.204078420899,
			"8.1-8.4": 0.377026235221,
			"9.0-9.2": 0.179865726894,
			"9.3": 2.74410532057
		},
		"android": {
			"3": 0,
			"4": 0.0201678139535,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00252097674419,
			"4.1": 0.0727481860465,
			"4.2-4.3": 0.181870465116,
			"4.4": 0.417041581395,
			"4.4.3-4.4.4": 0.420642976744
		},
		"ie": {
			"6": null,
			"7": 0.0206289745455,
			"8": 0.275052993939,
			"9": 0.412579490909,
			"10": 0.295681968485,
			"11": 10.3419925721,
			"5.5": null
		},
		"op_mob": {
			"0": 0.020303154458,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000563976512722
		},
		"edge": {
			"12": 0.10302,
			"13": 1.023332,
			"14": 3.736192
		},
		"ie_mob": {
			"10": 0.142660394366,
			"11": 0.580831605634
		},
		"bb": {
			"7": 0.009396,
			"10": null
		},
		"samsung": {
			"0": 4.43178
		},
		"and_uc": {
			"0": 0.081432
		},
		"op_mini": {
			"0": 0.273540869029
		},
		"and_chr": {
			"0": 14.385428
		},
		"and_ff": {
			"0": 0.034452
		}
	},
	"total": 98.71792
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BE.json
 ** module id = 474
 ** module chunks = 0
 **/